/**
 * Minified by jsDelivr using Terser v3.14.1.
 * Original file: /npm/js-cookie@2.2.0/src/js.cookie.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
!function(e){var n=!1;if("function"==typeof define&&define.amd&&(define(e),n=!0),"object"==typeof exports&&(module.exports=e(),n=!0),!n){var o=window.Cookies,t=window.Cookies=e();t.noConflict=function(){return window.Cookies=o,t}}}(function(){function e(){for(var e=0,n={};e<arguments.length;e++){var o=arguments[e];for(var t in o)n[t]=o[t]}return n}return function n(o){function t(n,r,i){var c;if("undefined"!=typeof document){if(arguments.length>1){if("number"==typeof(i=e({path:"/"},t.defaults,i)).expires){var a=new Date;a.setMilliseconds(a.getMilliseconds()+864e5*i.expires),i.expires=a}i.expires=i.expires?i.expires.toUTCString():"";try{c=JSON.stringify(r),/^[\{\[]/.test(c)&&(r=c)}catch(e){}r=o.write?o.write(r,n):encodeURIComponent(String(r)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),n=(n=(n=encodeURIComponent(String(n))).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent)).replace(/[\(\)]/g,escape);var s="";for(var f in i)i[f]&&(s+="; "+f,!0!==i[f]&&(s+="="+i[f]));return document.cookie=n+"="+r+s}n||(c={});for(var p=document.cookie?document.cookie.split("; "):[],d=/(%[0-9A-Z]{2})+/g,u=0;u<p.length;u++){var l=p[u].split("="),C=l.slice(1).join("=");this.json||'"'!==C.charAt(0)||(C=C.slice(1,-1));try{var g=l[0].replace(d,decodeURIComponent);if(C=o.read?o.read(C,g):o(C,g)||C.replace(d,decodeURIComponent),this.json)try{C=JSON.parse(C)}catch(e){}if(n===g){c=C;break}n||(c[g]=C)}catch(e){}}return c}}return t.set=t,t.get=function(e){return t.call(t,e)},t.getJSON=function(){return t.apply({json:!0},[].slice.call(arguments))},t.defaults={},t.remove=function(n,o){t(n,"",e(o,{expires:-1}))},t.withConverter=n,t}(function(){})});

//# sourceMappingURL=/sm/203d9606ffea7a776ef56994ac4d4a1ab0a18611bf5f22fd2f82e9b682eea54f.map

/**
 * jQuery Unveil
 * A very lightweight jQuery plugin to lazy load images
 * http://luis-almeida.github.com/unveil
 *
 * Licensed under the MIT license.
 * Copyright 2013 Luís Almeida
 * https://github.com/luis-almeida
 */

;(function($) {

    $.fn.unveil = function(threshold, callback) {

        var $w = $(window),
            th = threshold || 0,
            retina = window.devicePixelRatio > 1,
            attrib = retina? "data-src-retina" : "data-src",
            images = this,
            loaded;

        this.one("unveil", function() {
            var source = this.getAttribute(attrib);
            source = source || this.getAttribute("data-src");
            if (source) {
                this.setAttribute("src", source);
                if (typeof callback === "function") callback.call(this);
            }
        });

        function unveil() {
            var inview = images.filter(function() {
                var $e = $(this);
                if ($e.is(":hidden")) return;

                var wt = $w.scrollTop(),
                    wb = wt + $w.height(),
                    et = $e.offset().top,
                    eb = et + $e.height();

                return eb >= wt - th && et <= wb + th;
            });

            loaded = inview.trigger("unveil");
            images = images.not(loaded);
        }

        $w.on("scroll.unveil resize.unveil lookup.unveil", unveil);

        unveil();

        return this;

    };

})(window.jQuery || window.Zepto);

/**
 * Ovládání cookies lišty
 */

class CookiesBar {
    constructor($container) {
        this.STORE_PREFIX = "COOKIES_POLICY_BAR";

        this.$container = $container;
        this.$btn = this.$container.find('.cookies-close');

        this.isHidden = Cookies.get(this.STORE_PREFIX);

        this.init();
    }

    show() {
        this.$container.css("display", "flex");
    }

    hide() {
        Cookies.set(this.STORE_PREFIX, true, { expires: 365 });
        this.$container.hide();
    }

    init() {
        if (!navigator.cookieEnabled) return;

        if (!this.isHidden) {
            this.show();
            this.$btn.on('click', () => this.hide());
        }
    }

}

/**
 * Ovládání cookies lišty
 */

class CookiesModal {
    constructor($container) {
        this.STORE_MARKETING = "COOKIES_MARKETING_MODAL";

        this.$container = $container;
        this.$closeBtn = this.$container.find('.todayHideBtn');

        this.isHidden = Cookies.get(this.STORE_MARKETING);

        this.init();
    }

    show() {
        this.$container.modal("show");
    }

    hide() {
        Cookies.set(this.STORE_MARKETING, true, { expires: 1 });
        this.$container.modal("hide");
    }

    init() {
        if (!navigator.cookieEnabled) return;

        if (!this.isHidden) {
            setTimeout(() => this.show(), 2000);
            this.$closeBtn.on('click', () => this.hide());
        }
    }

}

function isLocalStorageAvailable ()
{
    let test = 'test';
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch(e) {
        return false;
    }
}

/** Ovládání formulářů*/
class FormController {

    constructor($form, $msg, $recaptcha, recaptchaWidgetId) {
        this.$form = $form;
        this.$msg = $msg;
        this.$recaptcha = $recaptcha;
        this.$required = $form.find('[data-required]');

        this.recaptchaWidgetId = recaptchaWidgetId;
        this.recaptchaContainer = null;

        this.recaptchaVisible = false;
        this.recaptchaAlertInterval = false;
        this.ready = false;

        this.init();
        this.initRequired();
    }

    validate(type, value)
    {
        let re;

        switch (type) {
            case "email":
                re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(value).toLowerCase());
            case "tel":
                re = /(^\+[\d-]{1,}$)|(^$)/;
                return re.test(String(value).toLowerCase());
        }
    }
    
    checkRequired($r)
    {
        let valid = this.validate($r.data('required'), $r.val());

        if (!valid) {
            $r.popover({
                content: $r.data('error-message'),
                placement: 'top'
            });
            $r.popover('show');
        } else {
            $r.popover('dispose')
        }

        return valid;
    }

    hideRecaptchaAlert()
    {
        this.$recaptcha.find('.col-12 div div').popover('hide');
    }

    recaptchaAlert()
    {
        if (!this.recaptchaVisible) {
            this.recaptchaVisible = true;
            this.$recaptcha.collapse('show');
        }
        this.$recaptcha.find('.col-12 div div').popover({
            content: gv.cs ? 'Prosím zaškrtněte ochranu proti robotům.' : 'Please chceck spam protection.',
            placement: 'top'
        });
        this.$recaptcha.find('.col-12 div div').popover('show');

        this.recaptchaAlertInterval = setInterval(() => {
            if (grecaptcha.getResponse(this.recaptchaContainer).length !== 0) {
                this.hideRecaptchaAlert();
                clearInterval(this.recaptchaAlertInterval);
            }
        }, 200);
    }

    onSubmit(e)
    {
        e.preventDefault();

        let _this = this;
        this.ready = true;

        this.$required.each(function () {
            if (!_this.checkRequired($(this))) _this.ready = false;
        });

        console.log(grecaptcha.getResponse(this.recaptchaContainer).length);
        
        if (grecaptcha.getResponse(this.recaptchaContainer).length === 0){
            this.ready = false;
            this.recaptchaAlert();
        }

        if (this.ready) {
            this.send();
        }
    }

    send()
    {

        let _this = this;

        $.ajax({
            type: "POST",
            url: this.$form.data('action') + "/?" + Date.now(),
            data: this.$form.serialize(),
            success: (d) => {
                if (d.msg === "success") _this.onSuccess();
                    console.log(d);
            }
        });

        console.log("Send");
    }

    onSuccess()
    {
        this.$form[0].reset();

        this.$msg.collapse('toggle');
        this.$form.collapse('toggle');

        this.hitDataLayer(this.$form.data('layer'));

        $('.modal').on('hide.bs.modal', function () {
            $('.blur-on-modal-open').removeClass('blur-active');
        });
    }

    hitDataLayer(type = "undefined")
    {
        dataLayer.push({
            'formType' : type,
            'event' : 'contactForm'
        });
    }

    initRequired()
    {
        let _this = this;
        this.$required.each(function () {
            let $r = $(this);
            $r.on('blur change', () => {
                _this.checkRequired($r);
            })
        })
    }
    
    init()
    {
        this.$form.on('submit', (e) => {
            this.onSubmit(e);
        });

        this.$form.find('[name]').on('click focus', () => {
            if (!this.recaptchaVisible) {
                this.recaptchaVisible = true;
                this.$recaptcha.collapse('show');
            }
        })
    }
    
}

/** Velikost elementů výška dle šířky*/
class HeightByWidth {

    constructor($els) {
        this.$els = $els;
        return this;
    }

    set() {
        this.$els.each(function () {
            $(this).height($(this).width());
        });

        return this;
    }

}

/** Nastavení velikosti elementů dle jejich výšky */
class MarginTopByHeight {

    constructor($els) {
        this.$els = $els;
        return this;
    }

    set() {
        if (!this.$els[0]) return this;

        this.$els.each(function () {
            $(this).css('margin-top', -($(this).outerHeight()/2));
        });

        return this;
    }

}

/** Plnění kontaktních údajů */
class FillMe {

    constructor($items) {
        this.$items = $items;

        return this;
    }

    static decrypt(hash) {
        return window.atob(hash);
    }

    static hash(str) {
        return window.btoa(str);
    }

    fillAll() {
        this.$items.each(function () {
            let $el = $(this);
            let content = FillMe.decrypt($el.data('hash'));
            let link = $el.attr('href') + content;

            $el.attr('href', link);

            if (!$el.data('no-text')) $el.text(content);

        });

        return this;
    }

}

/** Custom collapse u Služeb */
class CustomCollapse {

    constructor($el) {
        this.$el = $el;
        this.$container = this.$el.children();
        this.$items = this.$container.children();

        this.$btn = $('.custom-collapse-btn');

        this.itemsInRow = 0;
        this.displayItems = 9;
        this.itemsCount = this.$items.length;

        this.visible = false;

        this.init();
    }

    getItemsInRow() {
        return Math.floor(this.$container.outerWidth() / this.$items.outerWidth());
    }

    hideOverItems(ww) {

        if (ww < 768) this.displayItems = 4;
        else if (ww < 992) this.displayItems = 6;
        else this.displayItems = 9;

        this.itemsInRow = this.getItemsInRow();

        let overflowHeight = -(Math.ceil((this.itemsCount - this.displayItems) / this.itemsInRow) * this.$items.outerHeight());

        this.$container
            .css('margin-bottom', overflowHeight)
            .data('mb', overflowHeight);

        setTimeout(() => {
            this.$container.addClass('initialized');
        });

        if (this.itemsCount <= this.displayItems) {
            this.$btn.hide();
        } else {
            this.$btn.show();
        }
    }

    toggle() {
        if (this.visible) {
            this.$container.css('margin-bottom', this.$container.data('mb')+'px');
            this.visible = false;
        } else {
            this.$container.css('margin-bottom', 0);
            this.visible = true;
        }
    }

    init() {
        let _this = this;

        this.hideOverItems($(window).width());

        $(window).resize(function () {
            _this.hideOverItems($(this).width());
        });

        this.$btn.on('click', function () {
            _this.$btn.toggleClass('active');
            _this.toggle();
        })
    }
}

/** Aktuality */
class NewsController {

    constructor() {
        this.$el = $('#news');
        this.$contentItems = null;
        this.hideLines = 4;
        this.lineHeight = 27;
        this.hideOver = this.hideLines * this.lineHeight;

        this.loadMoreBtnAnimationInterval = null;
        this.$loadMoreBtn = $('#news-load-more');
        this.moreUrl = "/ajax/news/";
        this.loadMoreBtnText = gv.en ? "Load more articles" : "Načíst další aktuality";
        this.loadMoreBtnTextFinish = gv.en ? "All articles are loaded" : "Načetl jste všechny články";
        this.lang = gv.en ? "EN_us" : "CS_cz";
        this.page = 1;
        this.downloading = false;

        this.loaded = false;

        return this;
    }

    initCollapse($btnCnt) {
        let _this = this;

        $btnCnt.show();

        $btnCnt.find('button').on('click', function() {
            let $collapse = $(this).parent().prev();
            $(this).toggleClass('active');

            if ($collapse.hasClass('active')) {
                $collapse.animate({height: _this.hideOver}, 300);
            } else {
                $collapse.animate({height: $collapse.data('ovfHeight')}, 300);
            }

            $collapse.toggleClass('active');
        })
    }

    hideOverLineText(resize) {
        let _this = this;

        this.$contentItems = this.$contentItems = this.$el.find('.news-content');

        this.$contentItems.each(function () {
            let $el = $(this);
            $el.css('height', 'auto').data('ovfHeight', $el.height());

            if (resize && $el.height() > _this.hideOver) {
                $el.height(_this.hideOver);
                $el.removeClass('active').next().find('button').removeClass('active')
            }

            if ($el.height() > _this.hideOver && !$el.data('ovfInitialized'))  {
                _this.initCollapse($el.next());
                $el.height(_this.hideOver).data('ovfInitialized', true);
            }
        });
    }

    animateButton(start) {
        let _this = this;
        if (start) {
            _this.$loadMoreBtn.html("&nbsp;");
            this.loadMoreBtnAnimationInterval = setInterval(function () {
                if (_this.$loadMoreBtn.html() === "&nbsp;.......") _this.$loadMoreBtn.html("&nbsp;");
                _this.$loadMoreBtn.html(_this.$loadMoreBtn.html() + ".");
            }, 300);
        } else {
            clearInterval(this.loadMoreBtnAnimationInterval);
            this.$loadMoreBtn.html(this.loadMoreBtnText);
        }
    }

    loadMore() {
        let _this = this;

        if (!this.downloading) this.animateButton(true);

        this.downloading = true;
        this.page ++;

        let url = this.moreUrl + this.page + "/" + this.lang + "/?" + Date.now();
        
        $.ajax({
            method: 'get',
            url: url,
        }).done(function(resp) {
            setTimeout(function () {
                console.log(resp);
                if (resp.length > 100) {
                    _this.$el.html(_this.$el.html() + resp);
                    _this.hideOverLineText();
                    _this.downloading = false;
                    _this.animateButton();
                } else {
                    _this.animateButton();
                    _this.$loadMoreBtn.html(_this.loadMoreBtnTextFinish).addClass('disabled');
                    _this.loaded = true;
                }
            }, 600);
        });

    }

    init() {

        let _this = this;
        this.hideOverLineText();

        $(window).resize(function () {
            _this.hideOverLineText(true);
        });

        this.$loadMoreBtn.on('click', function () {
            if (!_this.downloading && !_this.loaded) _this.loadMore();
        });

        return this;
    }

}

/** Ovládání oblíbených/srdíčka v hlavičce */
class FavoriteHeartController {

    constructor() {
        this.$btn = $('.btn-favorite');
        this.$cnt = $('.btn-favorite-inner');
        this.favorites = localStorage.getItem('unicity-favorite-items') ? JSON.parse(localStorage.getItem('unicity-favorite-items')) : [];
        this.favoritesLength = this.favorites.length;
        this.favoritesContainer = $('<span>'+this.favorites.length+'</span>');
        this.initialized = false;
    }

    displayFavorites() {
        this.initialized = true;
        if (this.favoritesLength === 0) this.favoritesContainer.hide();
        this.$cnt.append(this.favoritesContainer);
    }

    addFavorite() {
        if (this.favoritesLength === 0) {
            this.favoritesContainer.fadeIn();
        }

        this.favoritesLength += 1;
        this.favoritesContainer.html(this.favoritesLength);
        let _this = this;

        setTimeout(function () {_this.$cnt.addClass('add-animate')});
        setTimeout(function () {_this.$cnt.removeClass('add-animate')}, 1000)
    }

    removeFavorite() {
        this.favoritesLength -= 1;

        if (this.favoritesLength === 0) {
            this.favoritesContainer.fadeOut();
        } else {
            this.favoritesContainer.html(this.favoritesLength);
            let _this = this;

            setTimeout(function () {_this.$cnt.addClass('remove-animate')});
            setTimeout(function () {_this.$cnt.removeClass('remove-animate')}, 1000)
        }
    }

    showFavorites() {
        if (!this.favoritesLength) {
            let _this = this;
            setTimeout(function () {_this.$cnt.addClass('no-fav-animate')});
            setTimeout(function () {_this.$cnt.removeClass('no-fav-animate')}, 600)
        } else if (typeof pricelist !== "undefined") {
            pricelist.$refs.filter.showFavorites();
        } else {
            if (gv.cs) {
                location.replace(gv.root_url + "/katalog-bytu/#oblibene");
            } else {
                location.replace(gv.root_url + "/en/apartment-catalogue/#favorite");
            }
        }
    }

    init() {
        this.displayFavorites();

        this.$btn.on('click', () => {
            this.showFavorites();
        });
        return this;
    }
}

/**
 * Ovládání externí filtrace na vrchu katalogu a na úvodní stránce
 */
class FlatFilter {

    // global var postFilterData

    constructor($cnt) {
        this.$cnt = $cnt;
        this.$form = $cnt.find('form');

        this.select2Selector = ".select2";
        this.select2Options = {
            theme: "classic",
            minimumResultsForSearch: -1
        };
        
        this.pricelistPage = (typeof pricelist !== "undefined");
        this.isSubmiting = false;

        this.init();
    }

    setPricelistFilter() {

        let filterData = {};

        this.$form.find('[id^=ff-]').each(function () {
            let $el = $(this);
            let key = $el[0].id.replace('ff-','');

            filterData[key] = $el.val();

        });

        pricelist.setPostFormFilterData(filterData);

        this.isSubmiting = false;
    }

    setFileterValue() {
        if (typeof postFilterData === "undefined") return;

        for (let val in postFilterData) {
            this.$form.find('#ff-'+val).val(postFilterData[val]).trigger('change');
        }

    }

    onSubmit() {
        if (this.pricelistPage) this.setPricelistFilter();
        else this.submit();
    }

    submit() {
        dataLayer.push({
            'dispozice' : this.$form.find('#ff-disposition').val(),
            'cena' : this.$form.find('#ff-price').val(),
            'event' : 'vyhledat'
        });

        this.$form.submit();
    }
    
    init() {
        $(this.select2Selector).select2(this.select2Options);

        this.$form.on('submit', (e) => {
            if (this.isSubmiting) return;
            this.isSubmiting = true;
            e.preventDefault();
            this.onSubmit();
        });

        this.setFileterValue();
    }

}

/**
 *
 * Ovládání parallaxu
 */
class Parallax {

    constructor() {
        this.controller = new ScrollMagic.Controller();

        this.hpSceneTopSelector = "#hp-parallax-scene-top";
        this.$hpSceneTopElement = $(this.hpSceneTopSelector);
        if (this.$hpSceneTopElement[0]) this.initHpSceneTop();

        this.hpSceneBotSelector = "#hp-parallax-scene-bot";
        this.$hpSceneBotElement = $(this.hpSceneBotSelector);
        if (this.$hpSceneBotElement[0]) this.initHpSceneBot();

        this.hpSceneProjectSelector = "#project";
        this.hpSceneProjectElement = $(this.hpSceneProjectSelector);
        if (this.hpSceneProjectElement[0]) this.initHpSceneProject();

        return this;
    }

    initHpSceneTop() {

        new ScrollMagic.Scene({
            triggerElement: this.hpSceneTopSelector,
            duration: this.$hpSceneTopElement.height() * 2,
            offset: -this.$hpSceneTopElement.height()/2,
        })
            .addTo(this.controller)
            .on("progress", (e) => {
                this.$hpSceneTopElement.css('background-position', 'center ' + (75 + (-50 * e.progress.toFixed(3)))+'%');
            });

        return this;
    }

    initHpSceneBot() {

        new ScrollMagic.Scene({
            triggerElement: this.hpSceneBotSelector,
            duration: this.$hpSceneBotElement.height() * 2,
            offset: -this.$hpSceneBotElement.height()/2,
        })
            .addTo(this.controller)
            .on("progress", (e) => {
                this.$hpSceneBotElement.css('background-position', 'center ' + (50 + (-50 * e.progress.toFixed(3)))+'%');
                // this.$hpSceneBotElement.css('background-position', 100 * e.progress.toFixed(3)+'% center');
            });

        return this;
    }

    initHpSceneProject() {

        new ScrollMagic.Scene({
            triggerElement: this.hpSceneProjectSelector,
            duration: this.hpSceneProjectElement.height() * 2,
            offset: -this.hpSceneProjectElement.height()/2,
        })
            .addTo(this.controller)
            .on("progress", (e) => {
                this.hpSceneProjectElement.css('background-position', 'center ' + (50 + (-50 * e.progress.toFixed(3)))+'%');
                // this.$hpSceneBotElement.css('background-position', 100 * e.progress.toFixed(3)+'% center');
            });

        return this;
    }

}

window.isMobile = function() {
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
};

// class ExampleClass {
//
//     constructor() {
//        this.name = 'Martin';
//
//         return this;
//     }
//
//     static hello(name) {
//         alert(`Hello ${name}`);
//     }
//
//     init() {
//         ExampleClass.hello(this.name);
//
//         return this;
//     }
//
// }
//

class DynamicGallery {

    constructor() {
        this.lg = null;
    }

    static option() {
        return {
            dynamic:            true,
            dynamicEl:          [],
            thumbWidth:         140,
            videoMaxWidth:      '95%',
            loadVimeoThumbnail: false,
            download:           false
        }
    }

    static slide(index) {
        setTimeout(() => DynamicGallery.lg.data('lightGallery').slide(index));
        return this;
    }

    static init(targetSelector) {
        if (typeof targetSelector === 'undefined') return;

        DynamicGallery.lg = $(targetSelector);

        if (DynamicGallery.lg.find('div').length < 1) return;

        let option = DynamicGallery.option();

        DynamicGallery.lg.find('div').each(function() {
            let $item = $(this);
            let dynamicElement = {
                src: $item.data('src'),
                iframe: $item.data('iframe'),
                thumb: $item.data('thumb'),
                subHtml: $item.data('sub-html')
            };

            option.dynamicEl.push(dynamicElement);
        });

        DynamicGallery.lg.lightGallery(option);

        return this;
    }

}


class GalleryItemHover {

    constructor($items) {
        this.$items = $items;
        this.zindex = 100;
    }

    riseUp($el) {
        $el.css('z-index', this.zindex++).addClass('rise-up');
    }

    fallDown($el) {
        $el.removeClass('rise-up');
    }

    initEvents() {
        let _this = this;
        this.$items.on('mouseenter', function () {
            _this.riseUp($(this))
        });
        this.$items.on('mouseleave', function () {
            _this.fallDown($(this))
        });

        return this;
    }
}
/**
 * Ovládání scroll up buttonu
 */

class ScrollUp {
    constructor($btn) {
        this.$btn = $btn;
        this.active = false;

        this.init();
    }

    show() {
        this.$btn.fadeIn();
        this.active = true;
    }

    hide() {
        this.$btn.fadeOut();
        this.active = false;
    }

    init() {
        if (!this.$btn[0]) return;
        let $w = $(window);

        this.$btn.on('click', () => $('html, body').animate({'scrollTop': 0}, 800));

        $w.on('scroll', (e) => {
            if ($w.scrollTop() > 3000 && !this.active) {
                this.show();
            } else if ($w.scrollTop() <= 3000 && this.active) {
                this.hide();
            }
        })
    }

}

/**
 * Main HP slider
 */
class MainSlider {

    constructor($container) {
        this.slider = null;
        this.$container =  $container;

        this.option = {
            item: 1,
            loop: true,
            controls: false,
            slideMove: 1,
            easing: 'cubic-bezier(1.000, -0.015, 0.625, 1.000)',
            speed: 2500,
            pause: 5000,
            pager: false,
            slideMargin: 0.0001,
            auto: true,
            mode: 'fade'
        };

        return this;
    }

    init() {
        this.slider = this.$container.lightSlider(this.option);

        return this;
    }
}


/**
 * ApartmentsSlider HP slider
 */
class ApartmentsSlider {

    constructor($container) {
        this.slider = null;
        this.$container =  $container;

        this.option = {
            item: 1,
            loop: false,
            controls: false,
            slideMove: 1,
            easing: 'cubic-bezier(1.000, -0.015, 0.625, 1.000)',
            speed: 1000,
            pause: 4000,
            pager: true,
            slideMargin: 30,
            auto: false,
            mode: 'fade'
        };

        return this;
    }

    initCustomControllers() {

        var customControllersHTML = "<div class=\"apartments-slider-controls\">\n" +
            "<div class=\"apartments-slider-prev\"><i class=\"arr left\"></i></div>\n" +
            "<div class=\"apartments-slider-next\"><i class=\"arr right\"></i></div>\n" +
            "</div>";

        var $pager = $('.apartments-slider-outer .lSPager');

        $pager.wrap('<div class="apartments-slider-controls-wrapper"></div>');

        var $wrapper = $pager.parent();

        $wrapper.append(customControllersHTML);
        $wrapper.find('.apartments-slider-prev').on('click', this.slider.goToPrevSlide);
        $wrapper.find('.apartments-slider-next').on('click', this.slider.goToNextSlide);

        return this;
    }

    init() {
        this.slider = this.$container.lightSlider(this.option);

        return this;
    }
}

/**
 * GallerySlider slider
 */
class GallerySlider {

    constructor($container) {
        this.slider = null;
        this.$container =  $container;

        this.option = {
            item: 1,
            loop: false,
            controls: false,
            slideMove: 1,
            easing: 'cubic-bezier(1.000, -0.015, 0.625, 1.000)',
            speed: 1000,
            pause: 4000,
            pager: true,
            slideMargin: 30,
            auto: false,
            mode: 'fade'
        };

        return this;
    }

    initCustomControllers() {

        var customControllersHTML = "<div class=\"gallery-slider-controls\">\n" +
            "<div class=\"gallery-slider-prev\"><i class=\"arr left\"></i></div>\n" +
            "<div class=\"gallery-slider-next\"><i class=\"arr right\"></i></div>\n" +
            "</div>";

        var $pager = $('.gallery-slider-outer .lSPager');

        $pager.wrap('<div class="gallery-slider-controls-wrapper"></div>');

        var $wrapper = $pager.parent();

        $wrapper.append(customControllersHTML);
        $wrapper.find('.gallery-slider-prev').on('click', this.slider.goToPrevSlide);
        $wrapper.find('.gallery-slider-next').on('click', this.slider.goToNextSlide);

        return this;
    }

    init() {
        this.slider = this.$container.lightSlider(this.option);

        return this;
    }
}


/**
 * ModalSlider slider
 */
class ModalSlider {

    constructor($container) {
        this.slider = null;
        this.$container =  $container;

        this.option = {
            item: 1,
            loop: true,
            controls: false,
            slideMove: 1,
            easing: 'cubic-bezier(1.000, -0.015, 0.625, 1.000)',
            speed: 1000,
            pause: 4000,
            pager: true,
            slideMargin: 30,
            auto: false,
            mode: 'fade'
        };

        return this;
    }

    initCustomControllers() {

        let customControllersHTML = "<div class=\"modal-slider-controls\">\n" +
            "<div class=\"modal-slider-prev\"><i class=\"arr left\"></i></div>\n" +
            "<div class=\"modal-slider-next\"><i class=\"arr right\"></i></div>\n" +
            "</div>";

        let $pager = $('.modal-slider-outer .lSPager');
        $pager.addClass('d-inline-block');

        $pager.wrap('<div class="modal-slider-controls-wrapper text-center"></div>');

        let $wrapper = $pager.parent();

        setTimeout(()=>{
            $wrapper.append(customControllersHTML);
            $wrapper.find('.modal-slider-prev').on('click', this.slider.goToPrevSlide);
            $wrapper.find('.modal-slider-next').on('click', this.slider.goToNextSlide);
        }, 500);

        return this;
    }

    init() {
        this.slider = this.$container.lightSlider(this.option);

        return this;
    }
}
/**
 * HomePage Vimeou Player
 */
class Nav {

    constructor() {

        this.$nav = $('#nav');
        this.$btn = $('#nav-toggler');
        this.$icon = this.$btn.find('button');

        this.activeClass = 'active';

        this.initEvents();
    }

    isOpen() {
        return this.$nav.hasClass(this.activeClass);
    }

    open() {
        if (this.isOpen()) return;
        this.$nav.addClass(this.activeClass);
        this.$icon.addClass(this.activeClass);
        dataLayer.push({ 'event' : 'clickMenu' });
    }

    close() {
        if (!this.isOpen()) return;
        this.$nav.removeClass(this.activeClass);
        this.$icon.removeClass(this.activeClass);
    }

    toggle() {
        if (!this.isOpen()) this.open();
        else if (this.isOpen()) this.close();
    }

    initEvents() {
        this.$btn.on('click', () => this.toggle())
    }

}
let GMap;

function initGoogleMap() {
    if (document.getElementById('map')) GMap = new GoogleMapController().init();
}

class GoogleMapController {

    constructor() {
        this.usePlaceholder = true;
        this.debugCoords = true;

        this.mapInitialized = false;
        this.graphicMapShow = false;

        this.placeholderIdName = 'map-placeholder';
        this.containerIdName = 'map';

        this.graphicMapBtn = null;
        this.graphicMap = null;
        this.placeholder = null;
        this.map = null;

        this.zoom = 14;
        this.lat = 49.72754683581853;
        this.lng = 13.35436465529483;

        // this.styles = [{"featureType":"landscape.natural","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#e0efef"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"hue":"#1900ff"},{"color":"#c0e8e8"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"geometry","stylers":[{"lightness":100},{"visibility":"simplified"}]},{"featureType":"road","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"visibility":"on"},{"lightness":700}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#7dcdcd"}]}];
        this.styles = [{"featureType":"landscape.natural","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#e0efef"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"hue":"#1900ff"},{"color":"#c0e8e8"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"geometry","stylers":[{"lightness":100},{"visibility":"simplified"}]},{"featureType":"road","elementType":"labels","stylers":[{"visibility":"on"},{"saturation":"0"},{"lightness":"60"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"visibility":"on"},{"lightness":700}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#7dcdcd"}]}];

        this.zoomDisable = false;

        this.markers = [];
        this.gMarkers = [];

        return this;
    }

    initMap() {
        this.map = new google.maps.Map(document.getElementById(this.containerIdName), {
            center: {lat: this.lat, lng: this.lng},
            zoom: this.zoom,
            styles: this.styles
        });
    }

    UpdateMarkersAfterZoom() {
        var map = this.map;
        var markers = this.markers;
        google.maps.event.addListener(map, 'zoom_changed', () => {
            if (!this.zoomDisable) {
                let zoomLevel = map.getZoom();
                for (let i = 0; i < markers.length; i++) {
                    if (markers[i].category === 'sluzby' || markers[i].category === 'mhd' || markers[i].category === 'obcerstveni') {
                        if (zoomLevel <= 14) {
                            markers[i].visible = false;
                            $(".filter-sluzby, .filter-mhd, .filter-obcerstveni").removeClass("active");
                        }

                        if (zoomLevel >= 15) {
                            markers[i].visible = true;
                            $(".filter-sluzby, .filter-mhd, .filter-obcerstveni").addClass("active");
                            this.zoomDisable = true;
                        }
                    }
                }

                this.markers = markers;
                this.updateMarkers();
            }
        });

        for (let i = 0; i < markers.length; i++) {
            if (markers[i].category === 'sluzby' || markers[i].category === 'mhd' || markers[i].category === 'obcerstveni') {
                markers[i].visible = false;
            }
        }
        this.updateMarkers();
    }

    initMarkers() {

        mapMarkers.forEach(m => {
            this.markers.push({
                title: m[0],
                position: {lat: m[2], lng: m[3]},
                icon: {
                    url: gv.content_url + "/images/icons/gm/" + m[4],
                    scaledSize: new google.maps.Size(m[5], m[5])
                },
                infoWindow: {
                    title: m[0],
                    content: m[1],
                },
                category: m[6],
                visible: true,
            });
        });

        this.markers.forEach(md => {
            let m = new google.maps.Marker( Object.assign(md, {map: this.map}));

            if (md.infoWindow.title !== "") {
                let c = "<p class='mb-1 font-weight-bold'>" +md.infoWindow.title+ "</p><br>";
                if (md.infoWindow.content) c += md.infoWindow.content;
                let iw = new google.maps.InfoWindow({content: c});
                m.addListener('click', function() { iw.open(map, m) });
            }

            this.gMarkers.push(m);
        });
    }

    filterMarkers(category, el) {
        for (let i = 0; i < this.markers.length; i++) {
            // If is same category or category not picked
            if(this.markers[i].category == category || category.length == 0)
            {
                this.markers[i].visible = !this.markers[i].visible;
            }
        }

        this.updateMarkers();
        this.setActiveClass(el);
    }

    updateMarkers() {
        this.gMarkers.forEach(marker => {
            marker.setMap(null);
        });
        this.gMarkers = [];

        this.markers.forEach(md => {
            if (!md.visible) {
                return;
            }

            let m = new google.maps.Marker( Object.assign(md, {map: this.map}));

            if (md.infoWindow.title !== "") {
                let c = "<p class='mb-1 font-weight-bold'>" +md.infoWindow.title+ "</p><br>";
                if (md.infoWindow.content) c += md.infoWindow.content;
                let iw = new google.maps.InfoWindow({content: c});
                m.addListener('click', function() { iw.open(map, m) });
            }

            this.gMarkers.push(m);
        });
    }

    setActiveClass(el) {
        $(el).toggleClass("active");
    }

    initCoordinatesDebug() {
        google.maps.event.addListener(this.map, 'click', function(event) {
            console.log('lat: ' + event.latLng.lat());
            console.log('lng: ' + event.latLng.lng());
            console.log('--------------------------');
        });
    }

    initPlaceholder() {
        this.placeholder = document.getElementById(this.placeholderIdName);
        this.placeholder.onclick = () => {

            if (this.mapInitialized) return false;

            this.mapInitialized = true;
            this.initMap();
            this.initMarkers();
            if (this.debugCoords) this.initCoordinatesDebug();

            setTimeout(() => {
                this.placeholder.style.display = "none";
            }, 200)
        }
    }

    initGraphicMap() {
        this.graphicMapBtn = document.getElementById('showGraphicMap');
        this.graphicMap = document.getElementById('graphic-map');

        this.graphicMapBtn.onclick = (e) => {
            e.preventDefault();
            $(this.graphicMap).toggleClass("active");
            $(this.graphicMapBtn).toggleClass("active");
        }
    }

    init() {
        this.initMap();
        this.initMarkers();
        this.initGraphicMap();
        this.UpdateMarkersAfterZoom();

        return this;
    }

}

/**
 *
 * Nadstavba nad vimeo player.js
 * Dokumentace - https://github.com/vimeo/player.js#embed-options
 */
class VimeoPlayer {

    constructor(elId, options, placeholderElId) {

        this.elId = elId;
        this.options = options;

        if (!this.checkRequired()) return;

        this.player = new Vimeo.Player(elId, options);
        this.placeholderEl = document.getElementById(placeholderElId);

        this.videoWidth = 0;
        this.videoHeight = 0;

        this.setSizeTimeout = null;

        this.setSize();
    }

    checkRequired()
    {
        return !!document.getElementById(this.elId)
    }

    setSize()
    {
        let $el = $("#"+this.elId);
        let $iframe = $el.find('iframe');
        let $wrappper = $('#main-page');

        let $placeholder = $('#video-bg-placeholder');
        let $overlay = $('#video-bg-overlay');

        let ww = window.outerWidth;
        let wh = window.outerHeight;
        
        let h = $wrappper.outerHeight() + 60;
        let w = (h / 9) * 16;
        let l = (w - ww) / 2;

        if (w < ww) {
            w = ww;
            h = (w / 16) * 9;
        }

        $placeholder.height(h);
        $overlay.height(h);

        $el.height(h);
        $iframe.height(h).width(w);

        $(window).on('resize', () => {
            clearTimeout(this.setSizeTimeout);

            this.setSizeTimeout = setTimeout(() => {
                this.setSize()
            }, 800)
        });

        return this;
    }

    fadePlaceholder()
    {
        if (!this.checkRequired()) return;

        this.player.on('play', () => {
            if (!this.placeholderEl) return;
            this.placeholderEl.className += " fade";
            this.getVideoSize();
            this.setSize();
        });

        return this;
    }

    getVideoSize()
    {
        this.player.getVideoWidth().then(val => this.videoWidth = val);
        this.player.getVideoHeight().then(val => this.videoHeight = val);
    }

    autoplay()
    {
        this.player.on('loaded', () => {
            this.fadePlaceholder();
            this.play();
        });
        return this;
    }

    play()
    {
        this.player.play();
        return this;
    }

    stop()
    {
        this.player.stop();
        return this;
    }

    volume(vol = 100)
    {
        this.player.setVolume(vol)
    }

}

// setTimeout(function() {location.reload(true)}, 5000);


/**
 * Inicializace menu
 */
new Nav();

/**
 * Inicializace cookie lišty
 */
new CookiesBar($('.cookies'));

/**
 * Inicializace cookie pro marketing modální okno
 */
new CookiesModal($('#marketingModal'));

/**
 * Inicializace globálního kontroleru oblíbených položek
 */
if (isLocalStorageAvailable()) {
    var favoriteHeartController = new FavoriteHeartController().init();
}

/**
 * Inicializace ovládání formulářů
 */
let contactForm = new FormController($('#contact-form-footer'), $('#contact-success-message'), $('#contact-form-recaptcha'), "contact-form-recaptcha-widget");
let askForm = new FormController($('#ask-form'), $('#ask-success-message'), $('#ask-form-recaptcha'), "ask-form-recaptcha-widget");

/**
 * Callback function Google Recaptcha
 */
var onloadRecaptchaCallback = function() {
    let siteKey = '6LfnSY0UAAAAAJMgIBhLKg0nfKAEdBm1vjoPxETa';

    if (contactForm.$form.length) {
        contactForm.recaptchaContainer = grecaptcha.render(document.getElementById(contactForm.recaptchaWidgetId), { 'sitekey' : siteKey });;
    }
    if (askForm.$form.length) {
        askForm.recaptchaContainer = grecaptcha.render(document.getElementById(askForm.recaptchaWidgetId), { 'sitekey' : siteKey });;
    }
};

/**
 * Inicializace sliderů
 */
let $mainSliderContainer = $('#main-slider');
if ($mainSliderContainer[0]) new MainSlider($mainSliderContainer).init();

let $apartmentsSlider = $('#apartments-slider');
if ($apartmentsSlider[0]) new ApartmentsSlider($apartmentsSlider).init().initCustomControllers();

let $gallerySlider = $('#gallery-slider');
if ($gallerySlider[0]) new GallerySlider($gallerySlider).init().initCustomControllers();

/**
 * Inicializace filtru/vyhledávače bytů
 */
let $flatFilter = $('#flat-filter');
if ($flatFilter[0]) new FlatFilter($flatFilter);
/**
 * Inicializace ovladače přehledu novinek
 */
new NewsController().init();

/**
 * Inicializace fill me funkce, která se stará o doplnění kontaktních údajů na stránku
 */
new FillMe($('.fill-me')).fillAll();

/**
 * Inicializace hoveru itemu v galerii
 */
new GalleryItemHover($('.gallery-item')).initEvents();

var hbw, mtbh, modalSlider;

$(function() {

    /**
     * Nastavení výšky elemntům dle jejich šířky
     */
    hbw = new HeightByWidth($('.h-by-w')).set();

    /**
     * Nastavení horního odsazení elemntům dle jejich výšky
     */
    mtbh = new MarginTopByHeight($('.mt-by-h')).set();

    /**
     * Inicializace slide down collapse služeb
     */
    let $customCollapse = $('.custom-collapse');
    if ($customCollapse[0]) new CustomCollapse($customCollapse);

    /**
     * Inicializace lazy load images
     */
    $("[data-src]").unveil();

    /**
     * Inicializace bootstrap tooltipů
     */
    $('[data-toggle="tooltip"]').tooltip();


    /**
     * Ovládání dynamické galerie na spodu stránky
     */
    $('[data-dynamic-gallery]').on('click', function () {
        DynamicGallery.init($(this).data('dynamic-gallery'));
        if ($(this).data('slide')) DynamicGallery.slide(parseInt($(this).data('slide')));
    });

    /**
     * Ovládání modálního okna o projektu
     */

    $('[data-target="#aboutProject"]').on('click', function () {
        $("#aboutProject").modal('show');
        if (typeof modalSlider === 'undefined') {
            modalSlider = new ModalSlider($('#modal-slider')).init().initCustomControllers();
        }
    });

    /**
     * Odstranění blur efektu
     */
    let $modals = $('.modal');
    $modals.on('hide.bs.modal', function () {
        $('.blur-on-modal-open').removeClass('blur-active');
    });

    $modals.on('hidden.bs.modal', function () {

        // dismiss all popovers (except grecaptcha box)
        $('[data-required]').popover('dispose')

        // dismiss contact-form popover
        $('#contact-form-recaptcha').find('.col-12 div div').popover('hide');

        // dismiss ask-form popover
        $('#ask-form-recaptcha').find('.col-12 div div').popover('hide');

        // remove blur effect
        $('.blur-on-modal-open').removeClass('blur-active');
 
    });

    $modals.on('show.bs.modal', function () {        

        // dismiss all popovers (except grecaptcha box)
        $('[data-required]').popover('dispose')

        // dismiss contact-form popover
        $('#contact-form-recaptcha').find('.col-12 div div').popover('hide');

        // dismiss ask-form popover
        $('#ask-form-recaptcha').find('.col-12 div div').popover('hide');

        // add blur effect
        $('.blur-on-modal-open').addClass('blur-active');
    });



    /**
     * Boxíky se službami
     */
    let $sbox = $('.service-box');
    $sbox.on('click', function () { $(this).toggleClass('active') });
    $sbox.on('mouseenter', function () { $(this).addClass('active') });
    $sbox.on('mouseleave', function () { $(this).removeClass('active') });

    /**
     * Inicializace parallaxu
     */
    new Parallax();


    /**
     * Inicializace úvodního videa
     */
    new VimeoPlayer('video-bg', {
        id: 701253906,
        loop: true,
        background: true,
        responsive: true,
        muted: true,
        autoplay: true,
        title: false
    }, 'video-bg-placeholder').fadePlaceholder();
}); 


/**
 * Při změně velikosti okna
 */
$(window).on('resize', function () {
    hbw.set();
    mtbh.set();
}); 

/**
 * Click -> scroll to target
 */
$('[data-scroll-to]').on('click', function (e) {
    let $target = $($(this).data('scroll-to'));
    if ($target[0]) {
        e.preventDefault();
        $('html, body').animate({ 'scrollTop': $target.offset().top - 50 }, 800);
    }
});

/**
 *
 */
$(".show-phone-box").click(function(e){
    e.preventDefault();

    if ($(".phone-hidden-box").hasClass("active")) {
        $(".phone-hidden-box").removeClass("active");
    } else {
        $(".phone-hidden-box").addClass("active");
    }
});

